import type { ResponseFormatRow } from '../config/columns';

export const getFormInitialValues = (editing?: ResponseFormatRow | null) => {
  if (!editing) return { isActive: true };
  return {
    ...editing,
    // 约束条件：如果是对象，转换为 JSON 字符串
    constraints: editing.constraints
      ? typeof editing.constraints === 'string'
        ? editing.constraints
        : JSON.stringify(editing.constraints, null, 2)
      : '',
    // 正面词和负面词：直接使用数组格式（TagInput 组件需要）
    positiveWords: Array.isArray(editing.positiveWords)
      ? editing.positiveWords
      : editing.positiveWords
      ? JSON.parse(editing.positiveWords as any)
      : [],
    negativeWords: Array.isArray(editing.negativeWords)
      ? editing.negativeWords
      : editing.negativeWords
      ? JSON.parse(editing.negativeWords as any)
      : [],
  };
};
